export default __webpack_public_path__ + "static/media/product-14.aa6f7fb5.webp";